import { axiosInstance } from '../hooks/useAxios'
import { addArticleToFavorite } from '../api/addArticleToFavorite'
import { removeArticleFromFavorite } from '../api/removeArticleFromFavorite'

export async function favoriteHandler(
  value: boolean,
  id: string,
  type: string = 'events',
  update?: () => void
): Promise<void> {
  if (value) {
    await axiosInstance(addArticleToFavorite(type, id))
  } else {
    await axiosInstance(removeArticleFromFavorite(type, id))
  }

  update?.()
}
